import {useDispatch, useSelector} from 'react-redux'
import logo from 'assets/images/logo.png'
import {actions} from 'store/modules/authentication/actions'
import {useEffect, useRef, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {join, range, split} from 'lodash'
import {DefaultRoute} from 'utility/utility'

export const VerifyOTP = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const {mail = false, auth = false} = useParams()

  const [code, setCode] = useState([])
  const [email, setEmail] = useState('')
  const inputRefs = useRef([])

  const handleInputChange = (index, event) => {
    const {value} = event.target
    const _code = [...code]
    _code[index] = Number(value)
    setCode(_code)
    // If the input value is a number and there is a next input, move focus to the next input
    if (/^\d*$/.test(value) && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus()
    }
  }

  // Function to handle input keydown event for navigation
  const handleInputKeyDown = (index, event) => {
    const {key} = event
    const _code = [...code]
    _code.splice(index, 1)
    setCode(_code)
    // If the user presses backspace and the current input is empty, move focus to the previous input
    if (key === 'Backspace' && !event.target.value && inputRefs.current[index - 1]) {
      inputRefs.current[index - 1].focus()
    }
  }

  useEffect(() => {
    if (auth) {
      setCode(split(atob(auth), ''))
    }
  }, [auth])

  useEffect(() => {
    if (mail) {
      setEmail(atob(mail))
    }
  }, [mail])

  const [isInvalid, setIsInvalid] = useState(false)

  const {loading = false} = useSelector(state => state.authentication)

  const onSuccess = data => {
    const route = DefaultRoute(data.user)
    navigate(route, {replace: true})
  }

  const onError = message => {
    setIsInvalid(true)
  }

  const handleAuth = () => {
    setIsInvalid(false)
    dispatch(
      actions.login({
        email,
        code: Number(join(code, '')),
        onSuccess,
        onError
      })
    )
  }

  return (
    <div className="vw-login">
      <div className="vw-login__block">
        <div className="vw-login__block__form">
          <img src={logo} alt="Video Window Logo" />
          <div className="form-group">
            <label>Please check email for the 6-digit OTP</label>
            <div className="d-flex justify-content-between">
              {range(6).map(index => (
                <input
                  key={`otp-input-${index}`}
                  ref={el => (inputRefs.current[index] = el)}
                  type="text"
                  value={code[index] || ''}
                  placeholder="0"
                  maxLength="1"
                  className={`code form-control form-code-verify-box`}
                  onChange={event => handleInputChange(index, event)}
                  onKeyDown={event => handleInputKeyDown(index, event)}
                />
              ))}
            </div>
            {isInvalid && (
              <div className="text-danger mt-2">OTP is expired or invalid, Please try again!</div>
            )}
          </div>
          <div className="form-group form-check d-flex">
            <input type="checkbox" className="form-check-input" name="remember" />
            <label className="form-check-label">Remember me</label>
          </div>
          {!auth && (
            <p className="form-check-label mb-3">
              It may take a minute to receive your code, Also, check your spam folder, just in case
            </p>
          )}
          <button type="button" className="btn btn-primary btn-block" onClick={handleAuth}>
            {loading ? (
              <span className="spinner-border spinner-border-sm text-light" role="status"></span>
            ) : (
              <span>Next</span>
            )}
          </button>

          <div className="d-flex justify-content-between">
            <Link replace to="/authentication/login" className="pt-4">
              <span className="fal fa-long-arrow-left pr-2"></span>back
            </Link>
            <Link replace to="/authentication/login" className="pt-4">
              Resend
            </Link>
          </div>
        </div>
        <div className="vw-login__block__welcome"></div>
      </div>
    </div>
  )
}
